import React from "react";

const CompositionIcon = ({
  onClickFn = () => {},
  width = "25",
  height = "20",
  fill = "currentColor",
}) => {
  return (
    <svg
      className="cursor-pointer"
      onClick={onClickFn}
      width={width}
      height={height}
      viewBox="0 0 25 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3246_121)">
<path d="M6.83594 15.2109C6.45312 15.8359 6.25 16.5508 6.25 17.2852C5.85938 17.4219 5.4375 17.5 5 17.5C2.92969 17.5 1.25 15.8203 1.25 13.75V2.5C0.558594 2.5 0 1.94141 0 1.25C0 0.558594 0.558594 0 1.25 0H3.75H6.25H8.75C9.44141 0 10 0.558594 10 1.25C10 1.94141 9.44141 2.5 8.75 2.5V12.1055L6.83594 15.2148V15.2109ZM3.75 2.5V6.25H6.25V2.5H3.75ZM13.75 0H18.75H20C20.6914 0 21.25 0.558594 21.25 1.25C21.25 1.94141 20.6914 2.5 20 2.5V8.39453L24.5977 15.8672C24.8594 16.293 25 16.7852 25 17.2891C25 18.7852 23.7852 20 22.2891 20H10.2109C8.71484 20 7.5 18.7852 7.5 17.2891C7.5 16.7891 7.64062 16.2969 7.90234 15.8672L12.5 8.39453V2.5C11.8086 2.5 11.25 1.94141 11.25 1.25C11.25 0.558594 11.8086 0 12.5 0H13.75ZM15 2.5V8.75C15 8.98047 14.9375 9.20703 14.8164 9.40625L12.9102 12.5H19.5898L17.6836 9.40625C17.5625 9.21094 17.5 8.98438 17.5 8.75V2.5H15Z" fill={fill}/>
</g>
<defs>
<clipPath id="clip0_3246_121">
<path d="M0 0H25V20H0V0Z" fill={fill}/>
</clipPath>
</defs>
    </svg>
  );
};

export default CompositionIcon;